import { FC } from "react";

import { Note } from "../../modules/core/applications";
import { ShowDateCell } from "./ShowDateCell";
import { KTSVG } from "../../../_metronic/helpers";

import { ApplicationFileDownload } from "./ApplicationFileDownload";
import { useAuth } from "../../modules/auth";
import { isPopulatedArray, isValidString } from "../helpers";
import { orderBy } from "lodash";

type Props = {
  note: Note
}

export const NoteCard: FC<Props> = ({note}) => {
  const {currentUser} = useAuth();

  return (
  <div className={'d-flex flex-row align-items-center rounded px-4 py-2 mb-2 ' + (note.byUser ? 'bg-light-warning': 'bg-light-success')}>
    <span className='svg-icon svg-icon-warning me-5'>
      <KTSVG path='/media/icons/duotune/abstract/abs045.svg' className='svg-icon-1' />
    </span>
    <div className='flex-grow-1 me-2 d-flex flex-column gap-2'>
      <div className="d-flex flex-row gap-2 align-items-center">
        <div className='flex-grow-1 fw-bold text-gray-800 text-hover-primary fs-7 lh-sm' style={{whiteSpace: 'pre-line'}}>
          {note.message}&nbsp;
        </div >          
      </div>

      <div className='text-muted fw-semibold d-flex flex-row flex-wrap align-items-center gap-2 fs-8'>
        <div className="me-2">{`[${note.applicationState}]`}</div>
        { (currentUser?.isSetsco || note.applicationState.match(/(Inspection|Inspector Review|Component Check)(.*)Issue$/i) || note.applicationState === 'Program Manager Approval - Issue (I)') && 
        <>
        { note.byUser &&
        <div>{`by ${note.byUser.name}`}</div>
        }
        { note.byApplicant &&
        <div>{`by ${note.byApplicant.name}`}</div>
        }                
        </>
        }                
        { (note.attachments && note.attachments.length > 0) && 
        note.attachments.map((file, idx) => (
          <ApplicationFileDownload key={`file${idx}`} file={file} />                
        ))                    
        }                
      </div>            
    </div>                            
    <div>
      <ShowDateCell date_val={note.dteCr} stack={true}/>                            
    </div>
  </div>
  )
}



type NotesProps = {
  notes: Array<Note> | undefined
  blankText?: string
}

export const NoteCards = ({notes, blankText} : NotesProps) => {
  
  if (! (isPopulatedArray(notes))) {
    return (isValidString(blankText)) ? <div className="text-muted fs-7">{`${blankText}`}</div> : null;    
  }

  return orderBy(notes, ['dteCr'],['desc']).map((note, idx) => (
    <NoteCard key={`note${idx}`} note={note} />
  ))  
}